import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
  selector: 'child-cell',
  templateUrl: './content-checkbox.component.html',
  styleUrls: ['./content-checkbox.component.sass']
})
export class ContentCheckboxComponent {
  public params: ICellRendererParams;

  public agInit(params: any): void {
    this.params = params;
  }

  public stopEditing() {
    this.params.api.stopEditing(false);
  }

  public onValueChanged(e) {
    // this.params.api.updateRowData(this.params.data);
    this.params.node.setDataValue(this.params.colDef.field, this.params.value);
    this.stopEditing();
  }
}
